import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MagnifyingGlassIcon } from '@yonderland/andes-icons';
import { Box, Checkbox, Grid, IconButton, Stack, TextField } from '@yonderland/andes-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { generateTestId } from '../../../util/TestUtil';
const TEST_ID = 'store-locator-filter';
const getOpenAfterTime = (openAfterTime, storeTimeNotation) => {
    const hours = Math.floor(openAfterTime / 60);
    const minutes = openAfterTime % 60;
    const amPmNotation = hours >= 12 ? 'PM' : 'AM';
    return {
        hours: hours % storeTimeNotation,
        minutes: minutes !== 0 ? minutes : null,
        notation: storeTimeNotation === 12 ? amPmNotation : null,
    };
};
const defaultFiltersState = {
    openNow: false,
    openLate: false,
    openSunday: false,
    newShop: false,
};
export const StoreLocatorFilter = ({ defaultSearch = '', onFiltersChange, onSearchSubmit, openAfterTime, storeTimeNotation, errorMessage, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.store);
    const [filters, setFilters] = useState(defaultFiltersState);
    const [searchTerm, setSearchTerm] = useState(defaultSearch);
    const handleFilterChange = (filterKey) => (e) => {
        const newFilters = Object.assign(Object.assign({}, filters), { [filterKey]: e.target.checked });
        setFilters(newFilters);
        setSearchTerm('');
        onFiltersChange(newFilters);
    };
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };
    const handleSearchSubmit = () => {
        setFilters(defaultFiltersState);
        onSearchSubmit(searchTerm);
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSearchSubmit();
        }
    };
    const filtersConfig = [
        {
            name: 'openNow',
            translationKey: 'store.opennow.txt',
        },
        {
            name: 'openLate',
            translationKey: 'store.openafter.txt',
            translationParams: getOpenAfterTime(openAfterTime, storeTimeNotation),
        },
        {
            name: 'openSunday',
            translationKey: 'store.sunday.txt',
        },
        {
            name: 'newShop',
            translationKey: 'store.openrecently.txt',
        },
    ];
    return (_jsxs(Stack, { direction: "col", gap: "4", testId: TEST_ID, children: [_jsx(Grid, { columns: 12, children: _jsx(Grid.Cell, { span: { base: 12, md: 6, lg: 4 }, children: _jsx(Stack, { direction: "col", gap: "1", children: _jsx(TextField, { id: "store_filter", name: "store_filter", value: searchTerm, onKeyDown: handleKeyDown, onChange: handleSearchChange, type: "search", placeholder: t('store.location'), error: errorMessage ? t(errorMessage) : undefined, adornmentEnd: _jsx(IconButton, { testId: "store_locator_search_submit", onClick: handleSearchSubmit, type: "submit", icon: { source: MagnifyingGlassIcon }, size: "sm", variant: "plain" }), testId: generateTestId({ testId: TEST_ID, suffix: 'location' }) }) }) }) }), _jsx(Stack, { direction: "col", children: filtersConfig.map(filter => (_jsx(Box, { testId: generateTestId({ testId: TEST_ID, suffix: filter.name }), children: _jsx(Checkbox, { id: filter.name, name: filter.name, value: filter.name, label: t(filter.translationKey, filter.translationParams), checked: filters[filter.name], onChange: handleFilterChange(filter.name) }) }, filter.name))) })] }));
};
